
<div :id="content.idHTML" class="form-conteneur" :class="jel_getClassObject(content)">
  <!-- tag="div" nécessaire pour accessibilité, éviter div dans un span -->
  <ValidationObserver
    ref="observer"
    v-slot="{ invalid, validate }"
    :vid="'vobserver' + uniqueId"
    tag="div"
  >
    <Message :content="null"></Message>
    <b-form
      :id="'idFormulaire' + uniqueId"
      @submit="onSubmit($event)"
      @input="validate({ silent: true })"
    >
      <EditableArea
        v-if="content.formulaire"
        :content="content.formulaire"
        :parentTemplateId="metadata['mgnl:template']"
      />

      <div
        v-if="!isNewRegistrationFlow()"
        :class="[
          getClassBoutonContinuer(),
          isBtnSecondaire
            ? 'd-flex justify-content-center justify-content-md-start'
            : 'flex-column',
        ]"
      >
        <!-- TODO: 2023-05-05 CIAM Temporaire -->
        <!-- TODO: xclass et xdisabled -->
        <!-- TODO: Trouver une façon élégante de ne valider que les champs visibles -->
        <b-button
          type="submit"
          :variant="btnVariant"
          class="btn w-xs-auto w-md-auto hauteur px-4 my-2"
          :class="{ valid: !invalid }"
          :disabled="invalid || isSubmitted || isSubmittedSecondaire"
        >
          <span data-ga="continuer" class="d-inline-flex w-auto">
            <div v-if="isSubmitted" class="mr-1">
              <b-spinner small :label="$t('chargement')"></b-spinner>
            </div>
            {{ content.libBoutonContinuer }}
          </span>
        </b-button>

        <!-- Ajouts pour formulaire Canafe -->
        <b-button
          v-if="isBtnSecondaire"
          :href="$t('messageComponent.detailsCompte')"
          :variant="btnVariantSecondaire"
          class="d-flex justify-content-center align-items-center w-xs-auto w-md-auto hauteur px-4 my-2 ml-2"
          :class="{ valid: !invalid }"
          :disabled="invalid || isSubmitted || isSubmittedSecondaire"
        >
          <span data-ga="continuer" class="d-inline-flex w-auto">
            <div v-if="isSubmittedSecondaire" class="mr-1">
              <b-spinner small :label="$t('chargement')"></b-spinner>
            </div>
            {{ libBtnSecondaire }}
          </span>
        </b-button>
        <!-- Ajouts pour formulaire validation Identité VerifiedMe -->
        <b-link
          v-else-if="isLienSecondaire"
          type="submit"
          class="lienSecondaire"
          :class="{ valid: !invalid }"
          :disabled="invalid || isSubmitted || isSubmittedSecondaire"
          @click="formSubmit(content.typeBoutonSecondaire.tacheSecondaire)"
        >
          <div data-ga="continuer" class="d-inline-flex w-auto">
            <div v-if="isSubmittedSecondaire" class="mr-1">
              <b-spinner small :label="$t('chargement')"></b-spinner>
            </div>
            {{ contentLienSecondaire }}
          </div>
        </b-link>
      </div>
    </b-form>
    <!-- Fenêtre modale de confirmation optionnelle -->
    <b-modal
      :id="confirmationUUID"
      :title="content.confTitre"
      header-class="px-3 py-1"
      centered
      hide-footer
      no-hide-backdrop
      no-close-on-backdrop
      no-close-on-esc
    >
      <template #modal-header="{ close }">
        <div v-if="content.confTitre" class="row posBtnFermer">
          <h3
            class="compteClair titre mx-xl-0 mx-lg-0 pt-2 pl-2 pr-4"
            v-html="jel_replaceTokens(content.confTitre)"
          />
          <button class="btnClose" @click="close()">
            <svg-icon
              icon-name="icone-fermer-mince"
              color="$couleur-primaire"
              className="iconeFermer"
            ></svg-icon>
          </button>
        </div>
      </template>

      <div class="compteClair d-flex flex-column align-items-center mb-2 mt-n2 px-1">
        <div v-html="jel_replaceTokens(content.confTexte)"></div>
        <div class="flex-column" :class="getClassBoutonContinuer()">
          <b-button
            class="btn btn-primaire px-4 mb-2"
            @click="$bvModal.hide(confirmationUUID), formSubmit(content.tache)"
          >
            {{ libBtnConfirmer }}
          </b-button>
        </div>

        <b-link class="lienSecondaire mt-0" @click="$bvModal.hide(confirmationUUID)">
          {{ libBtnModifier }}
        </b-link>
      </div>
    </b-modal>
  </ValidationObserver>
</div>
